module.exports = __webpack_public_path__ + "img/file.f1454f81.png";